import React from 'react'
import { Stack, Box, Divider, IconButton } from '@mui/material'
import { Delete } from '@mui/icons-material'
import { useAtom } from 'jotai'
import { authAtom } from '../../../../actions'
import dayjs from 'dayjs'
import AudioPlayer from "react-h5-audio-player";
import 'react-h5-audio-player/lib/styles.css';

const ConnectionItem = ({ staff, note, schedule_time, attached_file, onRemove }) => {
    const [auth] = useAtom(authAtom)

    const getFileType = (url) => {
        if (!url || typeof url !== 'string') return null;

        const lowerUrl = url.toLowerCase();
        const cleanUrl = lowerUrl.split('?')[0];

        if (/\.(jpg|jpeg|png|gif|webp|bmp|svg)$/.test(cleanUrl)) return 'image';
        if (/\.(mp3|wav|ogg|m4a|aac|flac|webm)$/.test(cleanUrl)) return 'audio';

        return 'other'
    };

    const fileType = getFileType(attached_file);

    return (
        <Stack flexDirection='row' sx={{paddingBottom: '24px', borderBottom: '3px solid black'}}>
            <Stack style={{ flex: 1 }}>
                <Box>
                    <p>{`Người thêm: ${staff.full_name}`}</p>
                    <p>{`Thời gian: ${dayjs(schedule_time).format('HH:mm DD/MM/YYYY')}`}</p>
                    <p>{`Ghi chú: ${note ?? ''}`}</p>
                    {attached_file && (
                        <Box>
                            <p>File đính kèm:</p>
                            {fileType === 'image' && (
                                <img
                                    src={attached_file}
                                    alt='attached-file'
                                    style={{ maxWidth: '100%', maxHeight: '320px', borderRadius: 8 }}
                                />
                            )}
                            {fileType === 'audio' && (
                                <AudioPlayer
                                    src={attached_file}
                                    autoPlay={false}
                                    controls
                                />
                            )}
                            {fileType === 'other' && (
                                <a href={attached_file} target='_blank' rel='noopener noreferrer'>
                                    Mở file đính kèm
                                </a>
                            )}
                        </Box>
                    )}
                </Box>
                <Divider />
            </Stack>
            {auth.id === staff.id &&
                <IconButton onClick={onRemove} aria-label='delete' color='error'>
                    <Delete />
                </IconButton>
            }
        </Stack>
    )
}

export default ConnectionItem